/**
 * Consumption-chart series palette, shared by MyBrunata's chart and the ngwebbill
 * resident-overview graph. From Marketing, to align the charts with Brunata's corporate visual
 * identity. A chart with more series than colours wraps around and reuses the palette.
 */
export const BRUNATA_CHART_COLORS: ReadonlyArray<string> = [
    '#214579', // mybrunata b-blue-100
    '#87c1e0', // mybrunata b-blue-400
    '#00715c', // mybrunata b-green-100
    '#8dc89f', // mybrunata b-green-400
    '#e98619',
    '#eac04d', // mybrunata b-yellow-200
    '#59548e',
    '#9b90c5',
];
